module.exports = __webpack_public_path__ + "media/how-it-works/clothing-53c40db1.png";